import { useMemo } from 'react'
import { CmsBlogPost } from '../types'

export const blogPostUrl = (post: CmsBlogPost): string =>
  `/blog/${post.fields.slug}/`

export const useBlogPostUrl = (post: CmsBlogPost): string =>
  useMemo(() => blogPostUrl(post), [post])
